import { Box, Typography } from '@mui/material';

interface SubsectionHeaderProps {
  children: React.ReactNode;
}

export function SubsectionHeader({ children }: SubsectionHeaderProps) {
  return (
    <Box
      sx={{
        bgcolor: 'custom.deepTeal',
        color: 'common.white',
        height: (theme) => theme.spacing(3.5),
        px: 1,
        py: 0.5,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Typography component="h3" variant="overline" sx={{ lineHeight: 1 }}>
        {children}
      </Typography>
    </Box>
  );
}

export default SubsectionHeader;
